import {Component, OnDestroy, OnInit} from '@angular/core';
import {LocalizeRouterPipe} from "@gilsdav/ngx-translate-router";
import {MatAnchor, MatButton} from "@angular/material/button";
import {ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";
import {Subscription} from "rxjs";
import {LanguageService} from "../../../../shared/services/language.service";

@Component({
  selector: 'app-page-detail-admin',
  standalone: true,
  imports: [
    LocalizeRouterPipe,
    MatAnchor,
    RouterLink,
    RouterLinkActive,
    MatButton,
    RouterOutlet,
    TranslateModule
  ],
  templateUrl: './page-detail-admin.component.html',
  styleUrl: './page-detail-admin.component.css'
})
export class PageDetailAdminComponent implements OnInit, OnDestroy{
  pageId!: number;
  disableSections: boolean = false;
  private subscriptions: Subscription = new Subscription();

  constructor(
    public _languageService: LanguageService,
    private _route: ActivatedRoute) {
  }

  ngOnInit() {
    this.getRouteParams()
  }

  getRouteParams() {
    this.subscriptions.add(
      this._route.params.subscribe(params => {
        this.pageId = params['pageId'];
        this.disableSections = isNaN(Number(this.pageId));
      })
    );

  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

}
